<script>
export default {
    name: "DispenseForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500
                       rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
            patient: {},
        };
    },

    mounted() {

        this.$root.loading = true;
        Promise.allSettled([ this.fetchPatient(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(({data}) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },
    },
    components: {
        "prescriped-drugs": () => import('./tabs/PrescribedDrugs.vue'),
        "daily-orders": () => import('./tabs/DailyOrders.vue')
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                  <template v-slot:card-header>
                      <h5 class="font-semibold text-sm">Dispense Drugs</h5>
                  </template>
                  <template v-slot:card-body>
                      <div class="flex flex-wrap rounded border-2 border-green-500 sm:my-1">
                          <div class="w-full bg-green-500 p-tiny">
                              <h5 class="font-bold text-white text-sm">Patient Details</h5>
                          </div>
                          <div class="w-full flex flex-wrap">
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">{{ patient.names }}</h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">MRN: {{ patient.patienT_ID }}</h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">ID No: {{ patient.nationalid || `-` }}</h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">IPFile No: {{ patient.ipfileno || `-` }}</h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">OPFile No: {{ patient.opfileno || `-` }}</h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">Status: {{ patient.iS_OUTPATIENT ? `Outpatient` : `Inpatient` }}</h5>
                              </div>
                              <div class="md:w-1/2 sm:w-full p-tiny">
                                  <h5 class="font-bold text-sm">P Mode: {{ patient.pMode }}</h5>
                              </div>
                          </div>
                      </div>
                      <ul class="w-full flex border-b-2 border-gray-500">
                        <li class="-mb-px mr-1">
                          <a
                            href="javascript:void(0)"
                            @click.prevent="active = 0"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                                px-4 font-bold whitespace-no-wrap"
                            :class="active == 0 ? activeClass : inActiveClass"
                            >Prescribed Drugs</a
                          >
                        </li>
                        <li class="-mb-px mr-1">
                          <a
                            href="javascript:void(0)"
                            @click.prevent="active = 1"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                                px-4 font-bold whitespace-no-wrap"
                            :class="active == 1 ? activeClass : inActiveClass"
                            >Daily Orders</a
                          >
                        </li>
                      </ul>
                      <prescriped-drugs 
                        v-if="active === 0"
                        :patient="patient"
                      />
                      <daily-orders 
                        v-if="active === 1"
                        :patient="patient"
                      />
                  </template>
                  <template v-slot:card-footer>
                      <div class="w-full text-right">
                          <router-link class="btn-sm btn-danger text-xs rounded" :to="{ name: patient.iS_OUTPATIENT ? `pharmacy.patients.index` : `pharmacy.ip-drug-dispensing.index` }"><i class="fa fa-caret-left"></i> Back</router-link>
                      </div>
                  </template>
            </tail-card>
        </template>
        
    </tail-base-layout>
</template>
